import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Reviews from './components/Reviews';
import Location from './components/Location';
import Footer from './components/Footer';
import StickyButtons from './components/StickyButtons';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Services />
      <WhyChooseUs />
      <Reviews />
      <Location />
      <Footer />
      <StickyButtons />
    </div>
  );
}
